export default {
    "tv": "Thử việc",
    "ct": "Chính thức",
    "pn": "Phó nhóm",
    "ld": "Leader",
    "tp": "Trưởng phòng",
    "nv": "Nghỉ việc",
}
